import { configureStore } from '@reduxjs/toolkit';
import authReducer from './slices/authSlice';
import eventReducer from './slices/eventSlice';
import userReducer from './slices/userSlice';
import ticketReducer from './slices/ticketSlice';
import employeeReducer from './slices/employeeSlice';
import expenseReducer from './slices/expenseSlice';
import pymentReducer from './slices/paymentSlice';
import galleryReducer from './slices/gallerySlice';
import tournamentReducer from './slices/tournamentSlice';
import teamReducer from './slices/teamSlice';
import matchReducer from './slices/matchSlice';


const store = configureStore({
    reducer: {
        auth: authReducer,
        events: eventReducer,
        user: userReducer,
        tickets: ticketReducer,
        employees: employeeReducer,
        expenses: expenseReducer,
        pyment: pymentReducer,
        gallery: galleryReducer,
        tournaments: tournamentReducer,
        teams: teamReducer,
        matches: matchReducer
    },
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware({
            thunk: true,
        }),
});

export default store;
